var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMdCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 39,
    viewBox: "0 0 36 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18 .12C6.77.12.89 4.3.89 8.44v21.8A5.9 5.9 0 0 0 4 35.48c3.54 1.89 8.65 3 14 3s10.48-1.09 14-3a5.9 5.9 0 0 0 3.09-5.24V8.44C35.11 4.3 29.23.12 18 .12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C354",
    d: "M33.11 8.44c0 3.49-6.77 6.31-15.11 6.31S2.89 11.93 2.89 8.44c0-3.49 6.77-6.32 15.11-6.32S33.11 5 33.11 8.44z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 7.71,
    fill: "#DCA93B",
    rx: 10.39,
    ry: 3.68
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCA93B",
    d: "M6.41 34.42a26 26 0 0 0 5.05 1.44V31a25.5 25.5 0 0 1-5.05-1.45v4.87zM17.5 31.53a36.2 36.2 0 0 1-5-.41V36a36.21 36.21 0 0 0 5 .4v-4.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE921B",
    d: "M23.54 31.12a36.2 36.2 0 0 1-5 .41v4.91a36.21 36.21 0 0 0 5-.4v-4.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCA93B",
    d: "M5.41 29.05a12.75 12.75 0 0 1-2.52-1.59v2.78a3.93 3.93 0 0 0 2 3.48l.49.23.03-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE921B",
    d: "M29.59 29.5a25.5 25.5 0 0 1-5.05 1.5v4.91a26 26 0 0 0 5.05-1.44V29.5zM30.59 29.05V34l.49-.23a3.93 3.93 0 0 0 2-3.48v-2.83a12.75 12.75 0 0 1-2.49 1.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5BC41",
    d: "M6.41 27.1a24.84 24.84 0 0 0 5.05 1.45v-4.91a25.5 25.5 0 0 1-5.05-1.46v4.92zM23.54 23.81a37.79 37.79 0 0 1-5 .41v4.91a34.73 34.73 0 0 0 5-.41v-4.91zM17.5 24.22a37.79 37.79 0 0 1-5-.41v4.91a34.73 34.73 0 0 0 5 .41v-4.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCA93B",
    d: "M29.59 22.18a25.5 25.5 0 0 1-5.05 1.46v4.91a24.84 24.84 0 0 0 5.05-1.45v-4.92zM30.59 21.73v4.92a13.2 13.2 0 0 0 2.52-1.58v-4.92a12.72 12.72 0 0 1-2.52 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5BC41",
    d: "M5.41 21.73a12.72 12.72 0 0 1-2.52-1.58v4.92a13.2 13.2 0 0 0 2.52 1.58v-4.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C354",
    d: "M6.41 20.16a25.5 25.5 0 0 0 5.05 1.45V16.7a25.5 25.5 0 0 1-5.05-1.46v4.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5BC41",
    d: "M30.59 14.79v4.92c.9-.43 1.745-.963 2.52-1.59v-4.91a13.2 13.2 0 0 1-2.52 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C354",
    d: "M17.5 17.27a34.73 34.73 0 0 1-5-.41v4.92a36.2 36.2 0 0 0 5 .41v-4.92zM23.54 16.86a34.73 34.73 0 0 1-5 .41v4.92a36.2 36.2 0 0 0 5-.41v-4.92zM5.41 14.79a13.2 13.2 0 0 1-2.52-1.58v4.91a12.75 12.75 0 0 0 2.52 1.59v-4.92zM29.59 15.24a25.5 25.5 0 0 1-5.05 1.46v4.91a25.5 25.5 0 0 0 5.05-1.45v-4.92z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMdCoins);
export default __webpack_public_path__ + "static/media/ic_md_coins.44ae132cbdc15567a9e86c7898026b41.svg";
export { ForwardRef as ReactComponent };